import ApiBase from '../../ApiBase';

class View extends ApiBase {
    route = '/cms/elements/views';
}

export default new View();
